function bindSortable() {
  $('.sortable').sortable({
   handle: '.sortable-handle',
   onSort: function(evt) {
    updatePositions()
   }
  });
  $('.sortable').on('cocoon:after-insert', function(e, insertedItem) {
    updatePositions()
  })
  $('.sortable').on('cocoon:after-remove', function(e, insertedItem) {
    updatePositions()
  })
}

function updatePositions() {
  $('.sortable').children('.sortable-item:visible').each(function(index) {
    $(this).find('.sortable-position').html(index + 1);
    $(this).find('input.sortable-position').val(index + 1);
  });
}

document.addEventListener("turbolinks:load", function() {
  bindSortable()
})
